import {
  CLICK_PARAMS,
  DATE_ATTRIBUTES,
  ELEMENT_TYPES,
  PARAMS_CONSTANTS,
  PHONE_ATTRIBUTES,
  PRODUCTS,
} from '@tracking/components/constants';
import { removeEmptyKeys } from '@common/utils/object';

export function getGTMEventSection(target) {
  const gtmElement = target.closest('[data-gtm-section]');
  return gtmElement ? gtmElement.dataset.gtmSection : null;
}

export function getGTMSubProduct(target) {
  if (target) {
    const gtmElement = target.closest('[data-gtm-sub-product]');
    return gtmElement ? gtmElement.dataset.gtmSubProduct : null;
  }

  const currentPageSubProduct = document.querySelector(
    '[data-gtm-page-sub-product]',
  );

  return currentPageSubProduct
    ? currentPageSubProduct.dataset.gtmPageSubProduct : null;
}

export function getGTMElementName(target) {
  const attr = target.getAttribute('data-gtm-element')
    ?? target.getAttribute('data-name');
  if (attr) {
    return attr;
  }
  const parentElement = target.closest('.gtm-track-element');
  if (parentElement?.getAttribute('data-gtm-parent')) {
    return parentElement.getAttribute('data-gtm-parent');
  }
  return target.getAttribute('name');
}

export function getTargetElement(element) {
  if (element?.closest('.gtm-track-element')) {
    return element.closest('.gtm-track-element');
  }

  return element;
}

export function getGTMElementType(element) {
  if (!element) {
    return ELEMENT_TYPES.CTA;
  }
  const targetElement = getTargetElement(element);
  if (targetElement?.getAttribute('data-gtm-type')) {
    return targetElement.getAttribute('data-gtm-type');
  }
  if (element.type === 'submit') {
    return ELEMENT_TYPES.FORM_SUBMIT;
  }
  if (element.tagName?.toLowerCase() === 'input') {
    return ELEMENT_TYPES.FORM_INPUT;
  }
  return ELEMENT_TYPES.CTA;
}

export function getDestinationUrl(link) {
  if (!link) {
    return {};
  }
  let destinationLink = link;
  if (link.startsWith('/')) {
    destinationLink = window.location.origin + link;
  }
  try {
    const urlObj = new URL(destinationLink);
    let destinationPath = urlObj.pathname;
    if (!destinationPath.endsWith('/')) {
      destinationPath += '/';
    }
    return {
      destination_url: urlObj.href,
      destination_host: urlObj.host,
      destination_path: destinationPath,
    };
  } catch (e) {
    return {};
  }
}

export function paramsToObject(entries) {
  const result = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of entries) {
    if (PARAMS_CONSTANTS.includes(key)) {
      result[key] = value;
    }
    if (CLICK_PARAMS.includes(key)) {
      result.mktg_click_id = `${key}=${value}`;
    }
  }
  return result;
}

export function getEventProgram() {
  const program = document.querySelector(
    '[data-program]',
  )?.getAttribute('data-program');

  if (program === 'software_development') {
    return PRODUCTS.ACADEMY;
  } else if (program === 'data_science') {
    return PRODUCTS.DATA_SCIENCE;
  }

  return PRODUCTS.EVENTS;
}

export function getProduct(url, defaultProduct) {
  const urlPathArrs = url.split('/');
  if (urlPathArrs.includes('meetings')) {
    return PRODUCTS.DRONA;
  }
  if (urlPathArrs.includes('edge')) {
    return PRODUCTS.EDGE;
  }
  if (urlPathArrs.includes('academy')) {
    return PRODUCTS.ACADEMY;
  }
  if (urlPathArrs.includes('plus')) {
    return PRODUCTS.PLUS;
  }
  if (urlPathArrs.includes('contests') || urlPathArrs.includes('contest')) {
    return PRODUCTS.CONTESTS;
  }
  if (urlPathArrs.includes('know-where-you-stand-free-self-assessment-test')) {
    return PRODUCTS.SAT;
  }
  if (urlPathArrs.includes('codex')) {
    return PRODUCTS.CODEX;
  }
  if (urlPathArrs.includes('events') || urlPathArrs.includes('event')) {
    return getEventProgram();
  }
  if (urlPathArrs.includes('data-science-course')) {
    return PRODUCTS.DATA_SCIENCE;
  }
  if (urlPathArrs.includes('review')) {
    return PRODUCTS.REVIEW;
  }

  return defaultProduct;
}

function parsePhoneNumber(phoneNumber) {
  return phoneNumber?.replace(/[^0-9]/g, '');
}

export function convertAttribute(key, value) {
  if (DATE_ATTRIBUTES.includes(key)) {
    return new Date(value);
  }

  if (PHONE_ATTRIBUTES.includes(key)) {
    return parsePhoneNumber(value);
  }

  return value;
}


export function parseAttributes(attributes) {
  if (!attributes) {
    return {};
  }
  const parsedAttributes = {};

  Object.keys(attributes).forEach(key => {
    parsedAttributes[key] = convertAttribute(key, attributes[key]);
  });

  return removeEmptyKeys(parsedAttributes);
}

export function getGoogleClientId() {
  let clientId;
  if (document.cookie.match(/_ga=(.+?);/)) {
    clientId = document.cookie.match(/_ga=(.+?);/)[1].split(
      '.',
    ).slice(-2).join('.');
  }

  return clientId;
}
